import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import Loader from "../../shared/loader";
import axios from "axios";
import Select from "react-select";
import DatePicker from "react-date-picker";
import moment from "moment";

const AddProforma = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const selectInputRef = useRef();
  const [invoiceDate, setInvoiceDate] = useState(new Date());
  const [lrDate, setLrDate] = useState();
  const [partyData, setPartyData] = useState([]);
  const [products, setProducts] = useState([]);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [charges, setCharges] = useState([]);
  const [productData, setProductData] = useState({
    name: "",
    product_id: "",
    sub_product_id: "",
    gst: "",
    qty: "",
    rate: "",
    amount: "",
  });
  const [formData, setFormData] = useState({
    party_id: "",
    invoice_no: "",
    prefix: "",
    insurance: "",
    insurance_amount: "0",
    is_igst: "",
    round_off: "0",
    sub_total: "0",
    tax_amount: "0",
    total_amount: "0",
    date: "",
    items: [],
  });

  const styles = {
    menu: (baseStyles, state) => ({
      ...baseStyles,
      marginTop: 2,
      zIndex: 999,
    }),
  };


  const setSelectedParty = (party_id) => {
    const party = partyData.find((r) => r.value == party_id);
    if (party) {
      setFormData({
        ...formData,
        party_id: party_id,
      });
    }
  };


  const getProforma = () => {
    axios.post(API_URL.PERFORMA_LATEST, {}).then((res) => {
      if (res.data.status === 1) {
        setFormData({ ...formData, prefix: res.data.prefix, invoice_no: res.data.data });
      }
    });
  };

  const getParty = () => {
    axios.post(API_URL.PARTY_LIST, {is_seller: [0]}).then((res) => {
      if (res.data && res.data.data && res.data.data.length > 0) {
        let pt = res.data.data.map((raw) => {
          return {
            name: raw.name,
            label: raw.name + " - " + raw.contact_no,
            value: raw.id,
          };
        });
        setPartyData(pt);
      }
    });
  };


  const getEdit = () => {
    axios.post(API_URL.PERFORMA_GET, { id: id }).then((res) => {
      if (res.data.status == 1) {
        setFormData({
          party_id: res.data.data.party_id ? res.data.data.party_id : "",
          invoice_no: res.data.data.invoice_no ? res.data.data.invoice_no : "",
          insurance: res.data.data.insurance ? res.data.data.insurance : "",
          insurance_amount: res.data.data.insurance_amount ? res.data.data.insurance_amount : "0",
          is_igst: res.data.data.is_igst ? res.data.data.is_igst : "",
          round_off: res.data.data.round_off ? res.data.data.round_off : "0",
          sub_total: res.data.data.sub_total,
          tax_amount: res.data.data.tax_amount,
          total_amount: res.data.data.total_amount,
          date: res.data.data.date ? res.data.data.date : "",
          remark: res.data.data.remark ? res.data.data.remark : "",
          prefix: res.data.data.prefix ? res.data.data.prefix : "",
          items: [],
        });
        if (res.data.data.date) {
          setInvoiceDate(new Date(res.data.data.date));
        }
        if (res.data.data.lr_date) {
          setLrDate(new Date(res.data.data.lr_date));
        }
        let rows = res.data.data.items.map((row) => {
          return {
            id: row.id,
            name: row.product.name + (row.subproduct ? " - " + row.subproduct.name : ""),
            gst: row.product.gst,
            qty: row.qty,
            rate: row.rate,
            amount: row.amount,
            product_id: row.product_id,
            sub_product_id: row.sub_product_id,
          };
        });
        setItems(rows);
      } else {
        toast.error(res.data.data, { autoClose: 3000 });
      }
      setLoading(false);
    });
  };


  const getProducts = () => {
    axios.post(API_URL.PRODUCT_WITH_SUB_LIST, {}).then((res) => {
      if (res.data && res.data.data && res.data.data.length > 0) {
        res.data.data.map((raw) => {
          raw.label = raw.name;
          raw.value = raw.id;
        });
        setProducts(res.data.data);
      }
      if (!id) {
        setLoading(false);
      }
    });
  };


  const setProductValue = (e) => {
    if (e) {
      setProductData({
        ...productData,
        name: e ? e.label : "",
        product_id: e ? e.product_id : null,
        sub_product_id: e ? e.sub_product_id : null,
        gst: e ? e.gst : "",
        rate: e.price ? e.price : 0,
        amount: (productData.qty) ? (productData.qty * e.price) : 0,
      });
    }
  };

  const addCharges = () => {
    let cpCharges = [...charges];
    cpCharges.push({
      title: "",
      amount: ""
    })
    setCharges(cpCharges);
  }

  const updateCharges = (val, field, ke) => {
    let cpCharges = [...charges];
    cpCharges[ke][field] = val;
    setCharges(cpCharges);
  }
  const removeCharges = (key) => {
    let cpCharges = [...charges];
    cpCharges.splice(key, 1);
    setCharges(cpCharges);
  }

  const addRow = () => {
    if (
      productData.product_id &&
      productData.qty &&
      productData.rate &&
      productData.amount
    ) {
      let cloneItems = [...items];
      cloneItems.push(productData);
      setItems(cloneItems);
      setProductData({
        name: "",
        product_id: "",
        sub_product_id: "",
        gst: "",
        qty: "",
        rate: "",
        amount: "",
      });
      selectInputRef.current.clearValue();
    }
  };
  const updateValue = (name, amt, value, k) => {
    const copyData = [...items];
    if (copyData[k]) {
      copyData[k][name] = value;
      if (name === "qty") copyData[k][amt] = value * copyData[k]["rate"];
      if (name === "rate") copyData[k][amt] = value * copyData[k]["qty"];
    }
    setItems(copyData);
  };

  const deleteRow = (index) => {
    const copyData = [...items];
    let newData = copyData.filter((e, key) => {
      return key != index;
    });
    setItems(newData);
  };

  const calculations = () => {
    let sub_total = 0;
    let total_qty = 0;
    let tax_amount = 0;
    items.forEach((row) => {
      sub_total += parseFloat(row.amount);
      total_qty += parseFloat(row.qty);
      tax_amount += (parseFloat(row.amount) * parseFloat(row.gst)) / 100;
    });
    let insurance_amount = 0;
    if (formData.insurance) {
      insurance_amount = (sub_total * formData.insurance) / 100;
      tax_amount += (parseFloat(insurance_amount) * 18) / 100;
      insurance_amount = insurance_amount.toFixed(2);
    }
    sub_total = sub_total.toFixed(2);
    let total_amount = parseFloat(sub_total) + parseFloat(insurance_amount);
    if (formData.round_off) {
      total_amount = parseFloat(total_amount) + parseFloat(formData.round_off);
    }
    if (tax_amount) {
      tax_amount = tax_amount.toFixed(2);
      total_amount = parseFloat(total_amount) + parseFloat(tax_amount);
    }
    if (charges.length) {
      charges.map((r) => {
        if (r.title && r.amount) {
          total_amount += parseFloat(r.amount);
        }
      });
    }
    total_amount = total_amount.toFixed(2);
    setFormData({
      ...formData,
      sub_total: sub_total,
      insurance_amount: insurance_amount,
      total_qty: total_qty,
      tax_amount: tax_amount,
      total_amount: total_amount,
    });
  };

  const isValidForm = () => {
    return (
      formData.party_id &&
      formData.prefix &&
      formData.invoice_no &&
      formData.sub_total &&
      formData.total_amount &&
      invoiceDate &&
      items.length
    );
  };

 const saveProforma = () => {
  let payload = { ...formData };
  payload.items = [...items];
  payload.additional_charges = [...charges];
  payload.date = moment(invoiceDate).format("YYYY-MM-DD");
  if (lrDate) {
    payload.lr_date = moment(lrDate).format("YYYY-MM-DD");
  }
  const pUrl = id ? API_URL.PERFORMA_UPDATE : API_URL.PERFORMA_SAVE;
  if (id) {
    payload.id = id;
  }

  setIsLoading(true);
  axios.post(pUrl, payload)
    .then((res) => {
      if (res.data.status === 1) {
        let message = id
          ? "Proforma Updated Successfully."
          : "Proforma Created Successfully.";
        toast.success(message, { autoClose: 3000, position: "top-right" });
        navigate("/sales/proforma");
      } else {
        toast.error(res.data.data || "Something went wrong", {
          autoClose: 3000,
          position: "top-right",
        });
      }
    })
    .catch((err) => {
      console.error("Error in saving proforma:", err);
      toast.error("Failed to save data", {
        autoClose: 3000,
        position: "top-right",
      });
    })
    .finally(() => {
      setIsLoading(false);
    });
};

useEffect(() => {
  calculations();
}, [items, formData.insurance, formData.round_off, charges]);

useEffect(() => {
  getParty();
  getProducts();
}, []);

useEffect(() => {
  if (id) {
    getEdit();
  } else {
    getProforma();
  }
}, [id]);
return (
  <>
    <div className="row">
      <div className="col-6">
        <h1>{id ? "Edit" : "Add"} Proforma</h1>
      </div>
      <div className="col-6">
        <div className="d-flex align-items-center  justify-content-end">
          <Link to={"/sales/proforma"} className="btn btn-secondary">
            <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
          </Link>
        </div>
      </div>
      <div className="col-md-12">
        {loading && <Loader></Loader>}
        {!loading && (
          <>
            <form onSubmit={(event) => event.preventDefault()}>
              <div className="row mt-3">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-header">Invoice Details</div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="name">Party</label>
                            <Select
                              options={partyData}
                              value={partyData.find(
                                (r) => r.value == formData.party_id
                              )}
                              styles={styles}
                              onChange={(e) => {
                                setSelectedParty(e.value);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="pan_no">Prefix</label>
                            <input
                              type="text"
                              className="form-control"
                              disabled
                              value={formData.prefix ? formData.prefix : ""}
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="invoiceno">Invoice No</label>
                            <input
                              type="text"
                              className="form-control"
                              value={formData.invoice_no}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  invoice_no: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="">Invoice Date</label>
                            <DatePicker
                              format={"dd/MM/y"}
                              className="form-control"
                              onChange={setInvoiceDate}
                              value={invoiceDate}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-header">Product Details</div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-5">
                          <div className="form-group">
                            <label htmlFor="exampleInputEmail1">Product</label>
                            <Select
                              ref={selectInputRef}
                              options={products}
                              styles={styles}
                              onChange={(e) => {
                                setProductValue(e);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <label htmlFor="exampleInputEmail1">Qty</label>
                            <input
                              type="number"
                              onChange={(e) => {
                                setProductData({
                                  ...productData,
                                  qty: e.target.value,
                                  amount:
                                    e.target.value * productData.rate
                                      ? e.target.value * productData.rate
                                      : 0,
                                });
                              }}
                              value={productData.qty}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <label htmlFor="exampleInputEmail1">Price</label>
                            <input
                              type="number"
                              onChange={(e) => {
                                setProductData({
                                  ...productData,
                                  rate: e.target.value,
                                  amount:
                                    e.target.value * productData.qty
                                      ? e.target.value * productData.qty
                                      : 0,
                                });
                              }}
                              value={productData.rate}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <label htmlFor="exampleInputEmail1">Amount</label>
                            <input
                              type="text"
                              value={productData.amount}
                              className="form-control"
                              disabled
                            />
                          </div>
                        </div>
                        <div className="col-md-1">
                          <div className="form-group">
                            <label>&nbsp;</label>
                            <div>
                              <i style={{ fontSize: 34, cursor: 'pointer' }} onClick={() => addRow()} className="simple-icon-plus"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {items.length > 0 && (
                      <table className="table table-hover">
                        <thead className="thead">
                          <tr>
                            <th>#</th>
                            <th colSpan={2} style={{ width: "45%" }}>Product</th>
                            <th>Qty</th>
                            <th>Price</th>
                            <th>GST</th>
                            <th>Amount</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {items.map((e, k) => {
                            return (
                              <tr key={k}>
                                <td>{k + 1}</td>
                                <td colSpan={2} style={{ width: "45%" }}>{e.name}</td>
                                <td>
                                  <input
                                    type="number"
                                    onChange={(event) => {
                                      updateValue(
                                        "qty",
                                        "amount",
                                        event.target.value,
                                        k
                                      );
                                    }}
                                    className="form-control form-control-sm"
                                    value={e.qty}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    onChange={(event) => {
                                      updateValue(
                                        "rate",
                                        "amount",
                                        event.target.value,
                                        k
                                      );
                                    }}
                                    className="form-control form-control-sm"
                                    value={e.rate}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={e.gst + "%"}
                                    disabled
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={e.amount}
                                    disabled
                                  />
                                </td>
                                <td style={{ cursor: "pointer", textAlign: 'right' }}>
                                  <i style={{ fontSize: 34, cursor: 'pointer' }} onClick={() => { deleteRow(k) }} className="simple-icon-close text-danger"></i>
                                </td>
                              </tr>
                            );
                          })}
                          <tr className="border-top">
                            <td
                              className="border-end"
                              colSpan={5}
                              align={"right"}
                            ></td>
                            <td className="border-end" align={"right"}>
                              <strong>Sub Total</strong>
                            </td>
                            <td colSpan={1} align={"right"}>
                              <strong>{formData.sub_total}</strong>
                            </td>
                            <td></td>
                          </tr>
                          {formData.insurance ? (
                            <tr className="border-top">
                              <td
                                className="border-end"
                                colSpan={5}
                                align={"right"}
                              ></td>
                              <td className="border-end" align={"right"}>
                                <strong>Insurance ({formData.insurance}%)</strong>
                              </td>
                              <td colSpan={1} align={"right"}>
                                <strong>{formData.insurance_amount}</strong>
                              </td>
                              <td></td>
                            </tr>
                          ) : null}
                          <tr className="border-top">
                            <td
                              className="border-end"
                              colSpan={5}
                              align={"right"}
                            ></td>
                            <td className="border-end" align={"right"}>
                              <strong>GST</strong>
                            </td>
                            <td colSpan={1} align={"right"}>
                              <strong>{formData.tax_amount}</strong>
                            </td>
                            <td></td>
                          </tr>
                          {charges.map((row, kk) => {
                            return <tr key={kk}>
                              <td colSpan={4}></td>
                              <td colSpan={2}>
                                <input type="text" className="form-control" value={row.title} onChange={(e) => updateCharges(e.target.value, 'title', kk)} />
                              </td>
                              <td colSpan={1}>
                                <input type="number" className="form-control" value={row.amount} onChange={(e) => updateCharges(e.target.value, 'amount', kk)} />
                              </td>
                              <td style={{ verticalAlign: 'middle' }}>
                                <i style={{ fontSize: 16, cursor: 'pointer' }} onClick={() => { removeCharges(kk) }} className="simple-icon-close text-danger"></i>
                              </td>
                            </tr>
                          })
                          }
                          <tr>
                            <td colSpan={3}></td>
                            <td colSpan={4} className="text-right">
                              <span style={{ cursor: 'pointer', color: 'blue' }} onClick={addCharges}>Additional Charges</span>
                            </td>
                            <td></td>
                          </tr>
                          <tr className="border-top">
                            <td className="vertical-middle">
                              <label htmlFor="remarks" className="mb-0">Remark</label>
                            </td>
                            <td className="border-end" colSpan={4}>
                              <input
                                id="remark"
                                type={"text"}
                                maxLength={255}
                                value={formData.remark}
                                placeholder="Remark"
                                className="form-control"
                                onChange={(e) =>
                                  setFormData({ ...formData, remark: e.target.value })
                                }
                              />
                            </td>
                            <td className="border-end vertical-middle" align={"right"}>
                              <strong>Round Off</strong>
                            </td>
                            <td colSpan={1} align={"right"}>
                              {" "}
                              <input
                                type={"number"}
                                value={formData.round_off}
                                className="form-control form-control-sm text-right"
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    round_off: e.target.value,
                                  })
                                }
                              />{" "}
                            </td>
                            <td></td>
                          </tr>
                          <tr className="border-top">
                            <td className="border-end" align={"right"} colSpan={6}>
                              <strong>Final Amount</strong>
                            </td>
                            <td align={"right"}>
                              <strong>{formData.total_amount}</strong>
                            </td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
            </form>
            <div className="col-lg-12 col-md-12 col-sm-12 mt-3">
              <div className="form-group text-right">
                <button
                  type="button"
                  onClick={saveProforma}
                  disabled={!isValidForm() || isLoading}
                  className="btn btn-primary"
                >
                  {isLoading ? (
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                    ></span>
                  ) : null}
                  Save
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  </>
);
};

export default AddProforma;
